import React from "react";
import TabLayout from "../../components/TabLayout";
import ReviewConfiguration from "./ReviewConfiguration";
import {Grid} from "@mui/material";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import BasicSettings from "./config/BasicSettings";

export default function SettingsAndConfigurationTabs(props) {
    return (
        <Grid container spacing={0.5}>
            <Grid item xs={12}><Typography variant="h5">System Configuration</Typography></Grid>
            <Grid item xs={12}><Divider/></Grid>
            <Grid item xs={12}>
                <TabLayout
                    tabs={[
                        {title: "Basic Configuration", component: <BasicSettings/>},
                        {title: "Review Url", component: <ReviewConfiguration/>}
                    ]}
                />
            </Grid>
        </Grid>
    );
}